import React from "react";
import Layout from "../../components/Layout/Layout";

import styles from "./CatalogPage.module.scss";

import PreviousPage from "../../components/partials/PreviousPage/PreviousPage";
import Sort from "../../components/pages/Catalog/Sort/Sort";
import Filters from "../../components/pages/Catalog/Filters/Filters";
import Goods from "../../components/pages/Catalog/Goods/Goods";
import Modal from "../../components/UI/Modal/Modal";

const goodsArr = [
  { id: 0, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 1, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 2, img: "/img/main/temp/3.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 3, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 4, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 5, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 6, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 7, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 8, img: "/img/main/temp/3.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 9, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 10, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 11, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
];

const CatalogPage: React.FC = () => {
  const [isFilterModalActive, setIsFilterModalActive] = React.useState(false);

  return (
    <Layout>
      <section>
        <div className="container">
          <Modal mode="filter" isActive={isFilterModalActive} setIsActive={setIsFilterModalActive} />
          <PreviousPage currentPage="Каталог тканей" />
          <Sort isFilterModalActive={isFilterModalActive} setIsFilterModalActive={setIsFilterModalActive} />
          <div className={styles.body}>
            <div className={styles.left}>
              <Filters />
            </div>
            <div className={styles.right}>
              <Goods goods={goodsArr} />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CatalogPage;
